import { lazyResetToRefinerFlyout } from "../../lazyFunctions";

export const onToRefinerClicked = (): void => {
    lazyResetToRefinerFlyout.import().then(resetToRefinerFlyout => {
        resetToRefinerFlyout();
    });
};
